//noScroll
class HamburgerEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    const hamBtn = document.querySelector(".js-hamTrigger")
    const hamContent = document.querySelector(".js-ham")
    const body = document.querySelector("body")

    hamBtn.addEventListener("click", () => {
      hamContent.classList.toggle("is-active")
      hamBtn.classList.toggle("is-open")
      body.classList.toggle("is-fixed")

    })

  }
}
